export default __webpack_public_path__ + "static/media/Leggings of the Precursor.7f63cc12.jpg";